import type { FaireProductEntity } from "../../entity_types/product";

export const p_57n9ms1e: FaireProductEntity = {
  token: "p_57n9ms1e",
  type: "product",
  name: "Coconut Milk Bath Bomb",
  brandToken: "b_cb27ceb3",
  brandName: "Old Whaling Company",
  imageUrl:
    "https://cdn.faire.com/fastly/8adfeff429f4d254148e9627a5e7528dba67285d963752f7bf4f42bd3547a59b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca56c161c638d0ca7e851f80ece6e2bc696c6d56ee7ec49e1452b98cd7a88dd1.jpeg",
    "https://cdn.faire.com/fastly/bdaa299ea0854343f5c34b8495b375345bbf4995154504550397c2d431fef021.jpeg",
    "https://cdn.faire.com/fastly/e50136ebbefa777a4c493ea0653e64b218c0366d20eb20d3c1c4abc7f010162a.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/e5e00c095e0609c07c65c8b996bd8bd25c0308757545100fe59900633c3fc940/1536338083.jpg",
    "https://cdn.faire.com/fastly/95f955e835d2389f811f8d95361e04bf95406432a7865269c2f5fc7b62caf8c0.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/71bd24b91f0c99fc05aaf6d6bbae79f1b9e2a7e53155123d6d4072d5b3f050f2/1534447285.jpg",
    "https://cdn.faire.com/fastly/b65a419559c0d1d01e8c956c7a8029c55ed205d8c16f82dc3d2278117c0cf81d.jpeg",
    "https://cdn.faire.com/fastly/9d1e0fa417769cc4d7f8345666f91bb3830f1e3d2501f3c1fc99524217839b2b.jpeg",
    "https://cdn.faire.com/fastly/ac72001b32d45dcf84b0e73dd3d53d5aa82f02c3d4b2dfa3b8d11fdb884ce45b.jpeg",
    "https://cdn.faire.com/fastly/71ffaacf998e9e77ec25a8628f2e62d872422d447f9a0ba5ba2125c187ccea0a.jpeg",
  ],
  priceDollars: 4,
  description:
    "This scent features the warm, tropical aroma of coconut milk paired with splashes of tropical fruit and inviting florals. This creamy tropical scent isn’t overly sweet, perfect for those who prefer a more subtle scent of summertime. Reminiscent of a relaxing getaway, Coconut Milk is a soothing escape from the everyday. \n\nTop: Coconut, Pineapple, Banana, Violet\nBase: Vanilla, Sandalwood, Musk\n\nMade in historic Charleston, SC, with baking soda, citric acid, epsom salts, olive & soybean oil, each Old Whaling Co. 8oz bath bomb will leave your skin feeling moisturized and lightly scented. Our handcrafted bath bomb's soothing fizz and sea-inspired fragrance are perfect for a relaxing soak, rejuvenating the senses and cleansing the skin.\n\nOur bath bombs come individually boxed, and are wrapped in cellophane bags inside the box to prevent oil from seeping onto the packaging. \n\nOur bath bombs always make for great gifts! ",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:27.203Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
